export default "<p>our-partners works!</p>\r\n"